<template>
    <div id="app">
        <navigation v-if="$route.name !== 'login'"></navigation>
        <transition name="main-anim">
            <router-view class="mb-5"></router-view>
        </transition>
        <bottom-footer v-if="$route.name !== 'login'"></bottom-footer>
    </div>
</template>

<script>
    export default {
        name: 'app'
    }
</script>

<style lang="scss" src="./app.scss"></style>



// WEBPACK FOOTER //
// src/App.vue